let StatusConst = {
  NEED_SAVE: 'needSave',
  SAVING: 'saving',
  SAVED: 'saved',
  CANCELING: 'canceling',
  CANCELED: 'canceled',
  ERROR: 'error',
  IDLE: 'idle',
  SENDING: 'sending',
  SENT: 'sent',
  LOADING: 'loading',
  LOADING_MORE: 'loadingMore',
  LOADED: 'loaded',
  NEW: 'new'
}

export default StatusConst



// WEBPACK FOOTER //
// ./src/utils/status.js